// components/CardSection.jsx
import React from 'react';
import InfoBlock from './InfoBlock';
import InfoBlockWInfo from './InfoBlockWInfo';

const CardSection = ({ title, blocks }) => {
    return (
        <div className="policy-card large-card">
            <div className="card">
                <div className="card-header large-card-header">
                    <h6>{title}</h6>
                </div>
                <div className="card-body">
                    {blocks.map((block, index) =>
                        block.info ? (
                            <InfoBlockWInfo key={index} label={block.label} value={block.value} info={block.info} />
                        ) : (
                            <InfoBlock key={index} label={block.label} value={block.value} />
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardSection;